import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { physicsData } from '../../data/departmentalData/physics';

const Physics = () => {
  return <TemplatePage data={physicsData} />;
};

export default Physics;
